import React from 'react'
import ReactDOM from 'react-dom';
import './blurBackground.scss'

const BlurBackground = () => {
	const content = (
		<div className="t-blur-background"></div>
	);

	const root = document.querySelector('#root');

	return ReactDOM.createPortal(content, root as Element);
}

export default BlurBackground;